import styled from 'styled-components';
import { palette } from 'styled-theme';

const AppHolder = styled.div `
  -webkit-overflow-scrolling: touch;
  .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 16px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .trigger:hover {
    color: ${palette('primary', 0)};
  }

  .ant-layout-sider-collapsed .anticon {
    font-size: 16px;
  }

  .ant-layout-sider-collapsed .nav-text {
    display: none;
  }

  .ant-layout {
    background: ${palette('secondary', 1)};

    &.isoContentMainLayout {
      overflow: auto;
      overflow-x: hidden;
      @media only screen and (min-width: 768px) and (max-width: 1220px) {
        width: calc(100% - 80px);
        flex-shrink: 0;
      }

      @media only screen and (max-width: 767px) {
        width: 100%;
        flex-shrink: 0;
      }
    }
  }

  .isoIconWrapper {
    position: relative;
    line-height: normal;

    span {
      font-size: 12px;
      color: #fff;
      background-color: ${palette('secondary', 1)};
      width: 20px;
      height: 20px;
      display: -webkit-inline-flex;
      display: -ms-inline-flex;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      line-height: 20px;
      position: absolute;
      top: -8px;
      left: ${props =>
        props['data-rtl'] === 'rtl' ? 'inherit' : '10px'};
      right: ${props =>
        props['data-rtl'] === 'rtl' ? '10px' : 'inherit'};
     
    }
  }
  
  .isoLayoutContent {
    width: 100%;
    padding: 35px;
    background-color: #FAFAFB !important;
    border: 1px solid ${palette('border', 0)};
    height: 100%;
  }

  .isomorphicLayout {
    width: calc(100% - 240px);
    flex-shrink: 0;
    overflow-x: hidden !important;

    @media only screen and (max-width: 767px) {
      width: 100%;
    }

    @media only screen and (min-width: 768px) and (max-width: 1220px) {
      width: calc(100% - 80px);
      width: 100%;
    }
  }

  .ant-layout-footer {
    font-size: 13px;
    @media (max-width: 767px) {
      padding: 10px 20px;
    }
  }

  ${'' /* button {
    border-radius: 0;
  } */};
`;

export default AppHolder;